// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".choices{margin-bottom:0!important}.qq-upload-button-custom{width:7rem}.not-allowed{cursor:not-allowed}.fw-bg-light{background-color:#eceff1;border:1px solid #ccd6e6;border-radius:.25rem}", ""]);
// Exports
module.exports = exports;
